import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.administrators.list', {
        url: '/list',
        component: 'companyAdministratorsList',
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/company/administrators/list/administrators-list.state.js